<script setup lang="ts">
import { CPSvgIcon } from '~/portal/components'
import type { ICPActionItemPropTypes } from '~/portal/components/base'

defineProps<ICPActionItemPropTypes>()

const emit = defineEmits<{
  (e: 'click'): void
}>()

const onClick = (): void => {
	emit('click')
}
</script>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<template>
	<div
		:class="[
			'cp-action-item',
			$attrs.class
		]"
		@click="onClick"
	>
		<CPSvgIcon
			v-if="icon"
			:name="icon"
			class="cp-action-item__icon"
		/>
		<span class="cp-action-item__inner">
			<slot>
				{{ text }}
			</slot>
		</span>
	</div>
</template>

<style lang="scss">
	.cp-action-item {
		@apply
			inline-flex
			items-center
			py-2
			pr-6
			pl-4
			font-medium
			text-cp-neutral-700
			cursor-pointer
			w-full

			hover:(
				text-cp-accent-200
				bg-cp-accent-50
			)
			active:text-cp-accent-300
		;

		&__icon {
			@apply
				mr-3
			;
		}

		&__inner {
			@apply
				first:ml-2
			;
		}
	}
</style>
